export const environment = {
    production: false,
    env: 'development',

    curriculumCmsApiUrl:
        'https://beta-curriculum-cms-api.thirdspacelearning.com/api',

    launchDarklyKey: '65c3877b9de2620f07deee88',

    keycloakUrl: 'https://nonprod-login.thirdspacelearning.com',
    keycloakRealm: 'staging',
    keycloakClientId: 'curriculum-cms-client',
};
